// extracted by mini-css-extract-plugin
module.exports = {"container":"_7db1a2e9","roomContainer":"_2f137536","image":"_a71e1fc9","imageWrapper":"_4e4d6d9a","shop":"_ed85e3aa","title":"_a9dccdce"};